namespace TabAurous.Retail {
    export namespace POSOrderForStockAllocationService {
        export const baseUrl = 'Retail/POSItemsForStockAllocation';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<POSOrderItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Retail/POSItemsForStockAllocation/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>POSOrderForStockAllocationService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
